import { onScroll, scrollTop } from '../utils/scroll';
import { nav } from './nav';

export function setupHeader() {
    const header = document.querySelector('.header');

    function setupSeoHeader(e) {
        const seo = header.nextElementSibling;

        if (seo.classList.contains('seo')) {
            const headerContent = header.querySelector('.header__content');
            const seoHeader = seo.querySelector('.seo__header');
            const seoHeaderContent = seo.querySelector('.seo__header__content');

            if (e) {
                if (e.type == 'orientationchange') {
                    seoHeader.style.height = null;
                    seoHeader.style.paddingTop = null;
                    seoHeaderContent.style.top = null;
                }
            }

            if (headerContent && seoHeader && seoHeaderContent) {
                const headerContentTop = headerContent.getBoundingClientRect().top + scrollTop;
                const seoHeaderHeight = seoHeader.offsetHeight;

                seoHeader.style.height = `${seoHeaderHeight}px`;
                seoHeader.style.paddingTop = '0';

                seoHeaderContent.classList.add('js-sticky');
                seoHeaderContent.style.top = `${headerContentTop}px`;
            }
        }
    }

    if (header) {
        if (nav) {
            const navHeight = nav.offsetHeight;
            let prevScroll = -1;

            /*if (document.body.classList.contains('page-template-frontpage')) {*/
            onScroll(() => {
                if (scrollTop > prevScroll) {
                    document.body.classList.add('js-scrolled');
                } else {
                    document.body.classList.remove('js-scrolled');
                }

                if (scrollTop > navHeight * 2) {
                    document.body.classList.add('js-nav-scrolled');
                } else {
                    document.body.classList.remove('js-nav-scrolled');
                }

                prevScroll = scrollTop;
            });
            /*}*/
        }

        /* If we're on a landingpage and the header has the 'header--sticky' class we know the next module is the 'SEO' module and that we want to slide the text down into that module */
        /* Set the heights and aadd the js-sticky class to the content. The CSS takes care of the rest */
        /*if (document.body.classList.contains('page-template-landingpage') && header.classList.contains('header--sticky')) {*/
        if (header.classList.contains('header--landingpage') && header.classList.contains('header--sticky')) {
            setTimeout(function() {
                setupSeoHeader();
            },250);

            window.addEventListener('orientationchange', function(e) {
                setTimeout(function() {
                    setupSeoHeader(e);
                },250);
            });
        }
    }
}